import React, { useCallback } from "react"
import { useRouter } from "next/router"

import { NewResourceButton } from "@/components/ResourceActionButton"
import { useQueryParams } from "@/hooks/useQueryParams"

interface AddWidgetButtonProps {
  dashboardId: string
  organizationSlug: string
}

export const AddWidgetButton: React.FC<AddWidgetButtonProps> = ({
  dashboardId,
  organizationSlug,
}) => {
  const router = useRouter()
  const queryParams = useQueryParams()

  const handleAddWidget = useCallback(() => {
    void router.push(
      queryParams.getHref(
        `/${organizationSlug}/dashboard/${dashboardId}/widgets/configure/new`,
      ),
    )
  }, [router, queryParams, organizationSlug, dashboardId])

  return (
    <NewResourceButton
      resourceName="Widget"
      onClick={handleAddWidget}
      data-testid="dashboard-add-widget-button"
    />
  )
}
